import React, { Component } from 'react';

// import { Route, Switch } from 'react-router-dom';
import {Route} from 'react-keeper';
import layouts from './../layouts';

import HomePage from './home/HomePage';
// import Home from './home/Home';
import routes from './../routes';
import {message} from 'antd'

class Paper extends Component {
    constructor(props) {
        super(props);
        
        const caches = {};
        const names = [];

        routes.forEach(item => {
            caches[item.name] = true;
            names.push(item.name);
        });

        this.state = {
            menuExpend: true,
            website: JSON.parse(sessionStorage.getItem('website') || '{}'),
            Offset: [220, 0],
            caches,
            names
        }
    }

    componentDidMount() {
        document.title = this.state.website.systemName;
    }

    setCache(cache) {
        const caches = Object.assign({}, this.state.caches, cache);
        this.setState((state) => {
            return Object.assign({}, state, {
                caches
            })
        });
    }

    toggle() {
        const menuExpend = !this.state.menuExpend;
        this.setState({
            menuExpend,
            Offset: menuExpend ? [220, 0] : [50, 0]
        });
    }

    filterModules(route){
        // const rules = JSON.parse(sessionStorage.session).rules
        // let modules = []
        // this.getChildren(rules , modules)
        // console.log(modules)
        // for(var i = 0 ; i < modules.length ; i++){
        //     const module = modules[i]
        //     if(module.indexOf(route.name) > -1){
        //         return true;
        //     }
        // }
        // message.error(`无法访问该模块【${route.name}】`)
        return true;
    }

    getChildren(rules , modules) {
        (rules||[]).map(r => {
            if(r.url){
                modules.push(r.url)
            }
            if(r.children ){
                this.getChildren(r.children , modules)
            }
        })
    }

    render() {
        const props = this.props;
        return (
            <layouts.Provider menuExpend={this.state.menuExpend} draggable={this.state.draggable}>
                <layouts.Header />
                <layouts.Menu
                names={this.state.names}
                Offset={this.state.Offset}
                menuExpend={this.state.menuExpend} 
                onMenuExpend={this.toggle.bind(this)}
                setCache={this.setCache.bind(this)} 

                onMenuDragStart={() => {
                    this.setState({
                        draggable: true
                    });
                }} 

                onMenuDragStop={(Offset) => {
                    this.setState({
                        Offset,
                        draggable: false
                    });
                    
                }}

                {...props} />
                <div className="root-wrapper-mains" style={{paddingLeft: this.state.Offset[0]}}>
                <layouts.Breadcrumb menuExpend={this.state.menuExpend} names={this.state.names} setCache={this.setCache.bind(this)} Offset={this.state.Offset} {...props} />
                    <>
                    <Route exact path="/" ></Route>
                    {routes.map((route, i) => {
                        const newProps = Object.assign({}, route, {
                            sitemap: props.sitemap,
                            name: route.name,
                            menuExpend: this.state.menuExpend,
                            Offset: this.state.Offset,
                            insertOrUpdateTab: props.insertOrUpdateTab,

                            onDragStart: () => {
                                this.setState({
                                    draggable: true
                                });
                            },

                            onDragStop: () => {
                                this.setState({
                                    draggable: false
                                });
                            }
                        });
                        // return <Route cache={this.state.caches[route.name]} component={route.component} path={route.path} {...newProps} ></Route>
                        return <Route 
                        path={route.path}
                        cache={this.state.caches[route.name]} 
                        sitemap={props.sitemap}
                        name={route.name}
                        menuExpend={this.state.menuExpend}
                        Offset={this.state.Offset}
                        insertOrUpdateTab={ props.insertOrUpdateTab}
                        onDragStart={
                            () => {
                                this.setState({
                                    draggable: true
                                });
                            }
                        }
                        onDragStop= {
                            () => {
                                this.setState({
                                    draggable: false
                                });
                            }
                        }
                        loadComponent={route.component}
                        key={i}
                        ></Route> 
                    })}
                    
                    </>
                </div>
                
            </layouts.Provider>
        )
    }
}

class Home extends Component {
    constructor(props) {
        super(props)
    }
    render() {
        return (
                <layouts.ViewPort>
                    <div  className='home-div' style={{margin : '0 auto' , width : '450px' , height : '450px'}}>
                        <img src='./../logo-gavtc.png' className='home-img' style={{width : '100%' , height : '100%' , top : '15%' , position : 'relative', opacity:0.3}}></img>
                    </div>
                </layouts.ViewPort>
            )
        }
    }

export default Paper;